import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { AppError, AppErrorCodes } from '@core/api';

@Component({
  selector: 'la-action-error',
  templateUrl: './action-error.component.html',
  styleUrls: ['./action-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule],
})
export class ActionErrorComponent implements OnInit {
  public error?: { title: string; message: string; details?: string };

  readonly data: AppError = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    if (this.data.code === AppErrorCodes.NO_INTERNET) {
      this.error = {
        title: 'No internet',
        message: `You're not connected to the internet at the moment, so any changes you make won't be saved. Please check your connection and try again.`,
      };
    } else if (this.data.code === AppErrorCodes.DEPRECATED) {
      this.error = {
        title: 'New version available',
        message: 'Please refresh your browser or clear your cache to ensure you are using the latest version of the Land App',
      };
    } else if (this.data.code === AppErrorCodes.INVALID_VERSION) {
      this.error = {
        title: 'Changes not saved',
        message: `We couldn't save your changes because your map was updated on another device before you reconnected to the internet. Please refresh your page to see the latest version of your map.`,
      };
    } else if (this.data.code === AppErrorCodes.SERVER_ERROR) {
      this.error = {
        title: 'Server error',
        message:
          'We are having trouble connecting to our servers at the moment. If you need urgent assistance, please get in touch with our support team on: support@thelandapp.com',
      };
    } else if (this.data.code === AppErrorCodes.POLYGONS_REQUIRED) {
      this.error = {
        title: 'Your plan must contain areas',
        message:
          'To create a data layer report, your plan needs to include areas. Please ensure your plan contains mapped areas, not just lines or points, and try again.',
      };
    } else if (this.data.code === AppErrorCodes.TOO_MANY_REQUESTS) {
      this.error = {
        title: 'Too many requests',
        message: `We're receiving too many requests at the moment. Please try again in a few minutes.`,
      };
    } else {
      this.error = { title: 'Error', message: this.data.message, details: this.data.details };
    }
  }
}
